import React from "react";

const OuterSignup = ({ setUserType }) => {
    return (
        <div className="flex flex-col space-y-8 items-center lg:my-0 my-8 justify-center">
            <div onClick={() => {
                setUserType("Client")
            }} className="flex md:w-[502px] w-[350px] cursor-pointer px-4 flex-row items-center justify-between" style={{
                height: "97px",
                background: "#139588",
                borderRadius: "5px"
            }}>
                <div className="space-x-8 flex flex-row items-center">
                    <div className="bg-white flex items-center justify-center" style={{
                        width: "76px",
                        height: "72.94px",
                        background: "#FFFFFF",
                        borderRadius: "6.37363px"
                    }}>
                        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2937_16403)">
                                <path d="M4.69838 38.77C4.69838 36.3091 4.69838 7.49553 4.69838 5.03248C7.25807 5.03248 34.565 5.03248 37.1247 5.03248C37.1247 5.90335 37.1247 10.073 37.1247 15.1993C37.7508 15.0893 38.393 15.0146 39.0514 15.0146C39.3887 15.0146 39.7075 15.0805 40.0402 15.1092V2.26367H1.78516V41.5388H25.8439V38.77C17.0881 38.77 6.26472 38.77 4.69838 38.77Z" fill="#139588" />
                                <path d="M8.82422 22.3277H28.5404C28.7341 21.2419 29.1167 20.2322 29.6192 19.2871H8.82422V22.3277Z" fill="#139588" />
                                <path d="M32.9088 9.7793H8.82422V12.8198H32.9088V9.7793Z" fill="#139588" />
                                <path d="M8.82422 31.8374H29.2642C29.8105 31.5055 30.3938 31.2358 31.0184 31.0698C30.426 30.3805 29.9396 29.6061 29.5247 28.7969H8.82422V31.8374Z" fill="#139588" />
                                <path d="M39.2762 32.9028C43.6653 32.9028 47.2014 29.3552 47.2014 24.9799C47.2014 20.6001 43.6652 17.0547 39.2762 17.0547C34.9056 17.0547 31.3672 20.6001 31.3672 24.9799C31.3672 29.3552 34.9056 32.9028 39.2762 32.9028Z" fill="#139588" />
                                <path d="M45.1364 34.3984H32.4349C30.1666 34.3984 28.3086 36.4777 28.3086 39.0388V51.7911C28.3086 51.9317 28.3731 52.0562 28.3823 52.2014H49.1773C49.1865 52.0585 49.2511 51.9317 49.2511 51.7911V39.0388C49.2604 36.4846 47.407 34.3984 45.1364 34.3984Z" fill="#139588" />
                            </g>
                            <defs>
                                <clipPath id="clip0_2937_16403">
                                    <rect width="51.0067" height="51.0067" fill="white" transform="translate(0.257812 0.222656)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <span className="md:text-[25px] text-[20px]" style={{
                        fontFamily: 'Inter',
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "34px",
                        color: "white"
                    }}>Register as a Client</span>
                </div>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 text-white h-12">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                </span>
            </div>
            <div onClick={() => {
                setUserType("Vendor")
            }} className="flex md:w-[502px] w-[350px] cursor-pointer px-4 flex-row items-center justify-between" style={{
                height: "97px",
                background: "#139588",
                borderRadius: "5px"
            }}>
                <div className="space-x-8 flex flex-row items-center">
                    <div className="bg-white flex items-center justify-center" style={{
                        width: "76px",
                        height: "72.94px",
                        background: "#FFFFFF",
                        borderRadius: "6.37363px"
                    }}>
                        <svg width="77" height="73" viewBox="0 0 77 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="76.0629" height="73" rx="6.37363" fill="white" />
                            <path d="M44.4529 19.4434V13.2734H26.9165V19.4434H23.0195V35.0311H33.1272L32.7619 32.1085H38.6073L38.2419 35.0311H48.3496V19.4434H44.4529ZM42.5043 19.4434H28.865V15.222H42.5043V19.4434Z" fill="#139588" />
                            <path d="M38.1987 36.9863L37.783 39.9093H33.348L32.9323 36.9863H21.1523V50.6258H49.9787V36.9863H38.1987Z" fill="#139588" />
                            <path d="M58.0881 20.4219H50.5391V50.6211H58.0881V20.4219Z" fill="#139588" />
                            <path d="M21.1477 19.4004H13.2773V50.5973H21.1477V19.4004Z" fill="#139588" />
                            <path d="M56.8943 39.065C62.7644 39.065 67.4937 34.3203 67.4937 28.4686C67.4937 22.6109 62.7643 17.8691 56.8943 17.8691C51.0489 17.8691 46.3164 22.6109 46.3164 28.4686C46.3164 34.3203 51.0489 39.065 56.8943 39.065Z" fill="white" />
                            <path d="M65.389 35.9316H48.4015C45.3677 35.9316 42.8828 38.7126 42.8828 42.1378V59.1932C42.8828 59.3813 42.9691 59.5478 42.9814 59.7421H70.7935C70.8058 59.551 70.8921 59.3813 70.8921 59.1932V42.1378C70.9046 38.7217 68.4258 35.9316 65.389 35.9316Z" fill="white" />
                            <path d="M56.961 37.3721C61.6564 37.3721 65.4393 33.5769 65.4393 28.8962C65.4393 24.2108 61.6563 20.418 56.961 20.418C52.2854 20.418 48.5 24.2108 48.5 28.8962C48.5 33.5769 52.2854 37.3721 56.961 37.3721Z" fill="#139588" />
                            <path d="M63.7444 38.7129H50.1565C47.7298 38.7129 45.7422 40.9373 45.7422 43.6771V57.3193C45.7422 57.4698 45.8112 57.603 45.8211 57.7583H68.0674C68.0772 57.6055 68.1462 57.4698 68.1462 57.3193V43.6771C68.1562 40.9446 66.1735 38.7129 63.7444 38.7129Z" fill="#139588" />
                        </svg>
                    </div>
                    <span className="md:text-[25px] text-[20px]" style={{
                        fontFamily: 'Inter',
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "34px",
                        color: "white"
                    }}>Register as a Vendor</span>
                </div>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 text-white h-12">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                </span>
            </div>
            <div onClick={() => {
                setUserType("Consultant")
            }} className="flex md:w-[502px] w-[350px] cursor-pointer px-4 flex-row items-center justify-between" style={{
                height: "97px",
                background: "#139588",
                borderRadius: "5px"
            }}>
                <div className="space-x-8 flex flex-row items-center">
                    <div className="bg-white flex items-center justify-center" style={{
                        width: "76px",
                        height: "72.94px",
                        background: "#FFFFFF",
                        borderRadius: "6.37363px"
                    }}>
                        <svg width="76" height="73" viewBox="0 0 76 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="76" height="72.9396" rx="6.37363" fill="white" />
                            <path d="M53.2915 43.2298V41.1258C53.2915 38.8114 51.3979 36.9177 49.0834 36.9177V17.9815C49.0834 15.6671 47.1898 13.7734 44.8754 13.7734H19.627C17.3126 13.7734 15.419 15.6671 15.419 17.9815V36.9177C13.1046 36.9177 11.2109 38.8114 11.2109 41.1258V43.2298C11.2109 45.5442 13.1046 47.4379 15.419 47.4379H49.0834C51.3979 47.4379 53.2915 45.5442 53.2915 43.2298ZM19.627 17.9815H44.8754V36.9177H19.627V17.9815ZM15.419 41.1258H49.0834V43.2298H15.419V41.1258Z" fill="#139588" />
                            <path d="M51.2254 39.0299C57.0906 39.0299 61.816 34.2891 61.816 28.4422C61.816 22.5894 57.0905 17.8516 51.2254 17.8516C45.3848 17.8516 40.6562 22.5894 40.6562 28.4422C40.6562 34.2891 45.3848 39.0299 51.2254 39.0299Z" fill="white" />
                            <path d="M59.7181 35.9004H42.7446C39.7133 35.9004 37.2305 38.679 37.2305 42.1014V59.1427C37.2305 59.3307 37.3167 59.497 37.329 59.6911H65.1181C65.1304 59.5002 65.2166 59.3307 65.2166 59.1427V42.1014C65.2291 38.6882 62.7523 35.9004 59.7181 35.9004Z" fill="white" />
                            <path d="M50.9657 36.3249C55.6572 36.3249 59.437 32.5328 59.437 27.856C59.437 23.1744 55.6571 19.3848 50.9657 19.3848C46.294 19.3848 42.5117 23.1744 42.5117 27.856C42.5117 32.5328 46.294 36.3249 50.9657 36.3249Z" fill="#139588" />
                            <path d="M57.7686 37.6992H44.1919C41.7672 37.6992 39.7812 39.9218 39.7812 42.6593V56.2903C39.7812 56.4406 39.8502 56.5737 39.8601 56.7289H62.088C62.0978 56.5762 62.1668 56.4406 62.1668 56.2903V42.6593C62.1767 39.9291 60.1956 37.6992 57.7686 37.6992Z" fill="#139588" />
                        </svg>
                    </div>
                    <span className="md:text-[25px] text-[20px]" style={{
                        fontFamily: 'Inter',
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "34px",
                        color: "white"
                    }}>Register as a Consultant</span>
                </div>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 text-white h-12">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                </span>
            </div>
        </div >
    )
}

export default OuterSignup